import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'


const Projects = ({openModal,setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects" >
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects. several web apps . Here are some of my projects.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'web app' ?
            <ToggleButton active value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
            :
            <ToggleButton value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
          }
          <Divider />
          {toggle === 'Small_web app' ?
            <ToggleButton active value="Small_web app" onClick={() => setToggle('Small_web app')}>Small web APP'S</ToggleButton>
            :
            <ToggleButton value="Small_web app" onClick={() => setToggle('Small_web app')}>Small web APP'S</ToggleButton>
          }
           {/* <Divider />
           {toggle === 'Research' ?
            <ToggleButton active value="Research" onClick={() => setToggle('Research')}>Research papers</ToggleButton>
            :
            <ToggleButton value="Research" onClick={() => setToggle('Research')}>Research papers</ToggleButton>
          }
       */}
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project) => (
              <ProjectCard  project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
          {projects
            .filter((item) => item.category === toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects